<template>
  <th class="text-center">
    <v-dialog
      v-model="dialog"
      content-class="rounded-xl"
      min-width="300px"
      max-width="600px"
      :loading="loading"
    >
      <template v-slot:activator="{ value, on: dialog }">
        <v-tooltip top>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
              :disabled="value"
              class="ma-2"
              small
              v-on="{ ...tooltip, ...dialog }"
            >
              <v-icon small>mdi-filter-menu</v-icon>
            </v-btn>
          </template>
          <span>Настройка шаблонов</span>
        </v-tooltip>
      </template>
      <template v-if="this.getTemplates().length">
        <v-card>
          <v-card-title>
            <span class="headline">Выбор текущего шаблона</span>
          </v-card-title>
          <v-card flat id="exact-coef">
            <v-card-text>
              <v-list>
                <!-- {{ templates }} -->
                <v-subheader> Шаблоны </v-subheader>
                <!-- <template v-if="items"> -->
                <v-list-item-group
                  v-if="this.getTemplates().length"
                  v-model="selectedTemplate"
                  color="primary"
                  @change="templateChange"
                >
                  <v-list-item
                    v-for="item in this.getTemplates()"
                    :key="item.id"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="item.name"></v-list-item-title>
                    </v-list-item-content>
                    <v-spacer></v-spacer>
                    <v-list-item-action>
                      <v-btn icon @click.stop="deleteTemplate(item.id)">
                        <v-icon color="grey lighten-1">mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <!-- <v-select
              label="Точное значение"
              small
              clearable
              :items="fighters"
              v-model="selected"
            ></v-select> -->
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn class="success" right @click="successClicked">
              <v-icon>mdi-check</v-icon>
            </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-card>
      </template>

      <v-card v-else>
        <v-card-title class="mx-center h1">
          Нет добавленных шаблонов
        </v-card-title>
        <v-img
          class="mx-auto"
          :src="require('../assets/confused.gif')"
          height="400"
          width="400"
        />
      </v-card>
      <!-- <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="success" @click="successClicked">
            <v-icon>mdi-check</v-icon>
          </v-btn> -->
      <!-- <v-btn class="error" @click="dialog = false">
            <v-icon> mdi-close </v-icon>
          </v-btn> -->
      <!-- </v-card-actions> -->
    </v-dialog>
  </th>
</template>

<script>
import api from "../config/api";
import { mapMutations, mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    url: "/templates/get_template/",
    remove_url: "/templates/remove_template/",
    selectedTemplate: null,
    loading: true,
  }),

  methods: {
    ...mapMutations({
      cleanSettings: "cleanAllFilters",
    }),
    ...mapGetters({ getTemplates: "getUserTemplates" }),
    ...mapActions([
      "cleanSettings",
      "setSettings",
      "setFilterKey",
      "setUserTemplates",
      "setFinishes",
      "fetchUserTemplates",
      "isTemplateChanged",
      "setTemplateUID",
      "setCurrentTemplate",
    ]),

    sortByDate: function (arr) {
      arr.sort(function (a, b) {
        var keyA = new Date(a.timestamp),
          keyB = new Date(b.timestamp);
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });
    },
    fetchTemplates: function () {
      // console.log("Fetching templates...");
      api
        .get(this.url)
        .then((response) => {
          this.templates = response.data;
          this.setUserTemplates({ value: response.data });
          // console.log("templates:" + JSON.stringify(this.templates));
          //   this.loading = false;
        })
        .catch((error) => {
          console.log(error.data);
        });
    },
    templateChange: function () {
      if (this.selectedTemplate == null) {
        // console.log("is empty!");
        this.cleanSettings();
        // this.setSettings();
        // this.setFinishes({ value: [] });
        this.$emit("filter_update");
        return;
      } else {
        // console.log("is not empty!");
        // console.log(this.selectedTemplate);
        // console.log(this.getTemplates());
        var current_template = JSON.parse(
          JSON.stringify(this.getTemplates()[this.selectedTemplate])
        );
        var template_name = current_template.name;
      }
      // console.log("Template changed to: " + JSON.stringify(current_template));
      this.cleanSettings();
      // console.log("current template!: " + JSON.stringify(current_template));
      this.setSettings({ value: current_template.settings });
      for (const [key, value] of Object.entries(
        current_template.settings.filters
      )) {
        // this.setFilterKey({ key, value });
        var valid_key = key;
        // console.log("VALUE:" + valid_key);
        if (valid_key.slice(-1) == "f") {
          valid_key = valid_key.replaceAll("_f", "");
          // console.log("Filter:" + valid_key);
        }
        this.$emit("selection_update", valid_key, value);
      }
      // console.log("Setting finishes:" + current_template.finishes);
      this.setTemplateUID({ value: current_template.uid });
      this.setCurrentTemplate({ value: template_name });

      this.isTemplateChanged();
      // this.setFinishes({ value: current_template.finishes });
      this.$emit("filter_update");
      // this.$store.dispatch({ type: "setFinishes", value: this.selected });
    },
    deleteTemplate(id) {
      // console.log("Deleting template: " + id);
      api.post(this.remove_url, { template_id: id }).then((response) => {
        console.log("response:" + response.data);
        this.fetchUserTemplates()
          .then(() => {
            var templates = JSON.parse(JSON.stringify(this.getTemplates()));
            // console.log("tempLautes: " + JSON.stringify(templates));
            if (templates.length == 0) {
              this.setTemplateUID({ value: "" });
              this.setCurrentTemplate({ value: "" });
              this.cleanSettings();
              this.$emit("filter_update");
              return;
            }
            this.setTemplateUID({ value: templates[0].uid });
            this.setCurrentTemplate({ value: templates[0].name });
            // this.isTemplateChanged();
            // this.setFinishes({ value: current_template.finishes });
            this.$emit("filter_update");
          })
          .catch((error) => {
            console.log(error.data);
          });
      });
      // this.templates.splice(id, 1);
    },
  },
  created() {
    // this.loading = true;
    this.fetchTemplates();
    // console.log("Loaded");
    this.loading = false;
  },
};
</script>

<style scoped></style>
